import React, { FC } from 'react'
import IconOptionsDots from '@vtex/styleguide/lib/icon/OptionsDots'

import ActionMenu, { MenuOption } from './ActionMenu'

type Props = {
  options: MenuOption[]
}

const InlineMenu: FC<Props> = ({ options }) => {
  return (
    <div className="inline-menu-container c-on-action-secondary f6 f5-ns">
      <ActionMenu
        isSimpleIcon
        shouldCloseOnClick
        icon={<IconOptionsDots />}
        showCaretIcon={false}
        boxWidth="100%"
        options={options}
        classNames="w2 h2 pt2"
      />
    </div>
  )
}

export default InlineMenu
